(($, Drupal, drupalSettings) => {
  Drupal.behaviors.availableTimesViews = {
    avt: function(el, settings) {
      this.initialize(el, settings);
      this.assisDent.getPersonsAvailableTimes(this.users, this.cleanExtraTimesOff.bind(this));
    },
    attach: (context, settings) => {

      var profiles = context.querySelector('article.profile--view-mode-listing-card');
      if (profiles) {

        const findUpperElement = (el,classes) => {
          if (el.classList.contains(classes)) { return el; }
          var parent = el.parentElement;
          while ( !parent.classList.contains(classes) ) {
            parent = parent.parentElement;
          }
          return parent;
        }

        var view = findUpperElement(profiles,'view-id-professionals');
        new Drupal.behaviors.availableTimesViews.avt(view, drupalSettings.availabletimesapi);
      }
    }
  }

  Drupal.behaviors.availableTimesViews.avt.prototype = {
    initialize: function (el, settings) {
      this.el = el;
      this.api = settings;

      const gatherUUIDs = () => {
        var r = [];
        this.el.querySelectorAll('article.profile--view-mode-listing-card').forEach( profile => {
          if (typeof profile.dataset.profileUuid !== 'undefined') {
            r.push(profile.dataset.profileUuid);
          }
          else {
            var timeContainer = profile.querySelector('.time-container');
            if(timeContainer) {
              timeContainer.parentElement.innerHTML = ''
            }
          }
        });
        return r;
      }

      this.users = gatherUUIDs();
      this.assisDent = new Drupal.assisDentCaller();
      el.classList.add('initializing');
    },

    cleanExtraTimesOff: function(data) {
      const addAvailableTime = (uuid, time) => {
        this.el.querySelectorAll('article.profile--view-mode-listing-card[data-profile-uuid="'+uuid+'"] .time-container').forEach( profile => {
          if( time !== null ){
            profile.innerHTML = '';
            time.ReasonId = 'none';
            profile.appendChild(
              this.assisDent.getUrlElementForAppoitment(time)
            );
            profile.parentElement.style.display = "";
          }
          else {
            profile.parentElement.innerHTML = '';
          }
        });
      }

      this.users.forEach( user => {
        addAvailableTime(user,data[user].length > 0 ? data[user][0] : null);
      });
    },

  };

})(jQuery, Drupal, drupalSettings);
